import { useDispatch, useSelector } from 'react-redux'
import { Link, Route, useParams } from 'react-router-dom'
import { useEffect } from 'react'
import {
  Card,
  CardBody,
  Row,
  Col,
  NavLink,
  NavItem,
  Nav,
  Input,
} from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ToastContainer } from 'react-toastify'
import {
  faArrowTrendUp,
  faCheck,
  faCode,
  faFile,
  faFileArchive,
  faFileImport,
  faFont,
  faGear,
  faLink,
  faPenAlt,
  faScrewdriverWrench,
  faVideo,
} from '@fortawesome/free-solid-svg-icons'

import * as courseActions from 'store/Course/actions'
import {
  getAllLanguages,
  getLanguages,
} from 'store/ConfigurationSettings/LanguageConfig/actions'
import { resetQuiz, fetchSubmission } from 'store/Quiz/actions'
import { fetchAllQuestions } from 'store/QuestionBank/actions'
import SortableContent from '../components/sortable/SortableContent'
import AddSubtitle from '../components/subtitle/AddSubtitle'
import AddText from '../components/text/AddText'
import AddHtml from '../components/html/AddHtml'
import ManageHtml from '../components/html/ManageHtml'
import AddVideo from '../components/video/AddVideo'
import AddFile from '../components/file/AddFile'
import AddScorm from '../components/scorm/AddScorm'
import AddExistingContent from '../components/AddExistingContent'
import ManageFile from '../components/file/ManageFile'
import ManageText from '../components/text/ManageText'
import ManageSubtitle from '../components/subtitle/ManageSubtitle'
import ManageVideos from '../components/video/ManageVideos'
import ManageScorm from '../components/scorm/ManageScorm'
import ManageLTI from '../components/lti/ManageLTI'
import AddLTIContent from '../components/lti/AddLTI'
import CourseSettings from './CourseSettings'
import ManageQuestions from '../components/ManageQuestions'
import ContentQuiz from '../components/ContentQuiz'
import ManageChecklist from '../components/checklist'
import defaultImage from 'assets/img/default-image.png'
import { invalidateCoursesOverview } from 'store/Dashboard/actions'
import CardHeaderButton from 'components/Custom/CardHeaderButton'
import Loader from 'views/pages/Loader'
// Custom css
import './style.css'

// Leon global css
import '../../../../../../src/assets/css/Global/style.css'
import { isTextEmpty } from 'utils/helpers'

function EditCourse() {
  const languageRedux = useSelector((state) => state.language?.language?.data)
  const language = languageRedux || {}

  const language_id = useSelector((state) => state.language.language?.id)
  const languages = useSelector((state) => state.language?.languages)
  const coursesOverview = useSelector((store) => store.dashboard)

  const courseState = useSelector((state) => state.courses)
  const quizState = useSelector((state) => state.quizes)
  const questionBankState = useSelector((state) => state.questionBank)
  const contentQuiz = useSelector((state) => state.courses.contentQuiz)

  const { id } = useParams()
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(courseActions.course(id))
    // dispatch(courseActions.fetchContents(id, courseState.language_id))
    dispatch(courseActions.fetchCourses())
    dispatch(fetchSubmission(id))
    dispatch(fetchAllQuestions())
    dispatch(getAllLanguages())
    dispatch(getLanguages())
    return () => {
      dispatch(courseActions.resetCourse())
      dispatch(resetQuiz())
    }
  }, [])

  return (
    <div className='col negative-margin'>
      <Card>
        <CardBody style={{ padding: '0.85rem' }}>
          <Row className='align-items-center flexColumn gap06 justifyBetween'>
            <div className='dFlex itemsCenter justifyCenter inputResponsive' style={{width: "100%"}}>
              <Col className='col-auto '>
                <img
                  className='rounded'
                  alt='...'
                  style={{
                    width: '80px',
                    height: '80px',
                    objectFit: 'cover',
                  }}
                  // src={require('assets/img/theme/team-5.jpg').default}
                  src={
                    courseState?.image?.includes(
                      'https://s3.eu-central-1.amazonaws.com/tazikis-app'
                    )
                      ? courseState.thumbValue
                        ? courseState.thumbValue
                        : defaultImage
                      : courseState.image
                      ? courseState.image
                      : defaultImage
                  }
                />
              </Col>
              <div className='col ml--2 d-flex gap1'>
                {/* <h4 className='mb-0'>{courseState.name}</h4> */}

                <Input
                  type='text'
                  value={courseState.name}
                  className='fontSizeResponsive inputResponsive  text-darker shadow-lg col2 md-col xs-col12'
                  name='name'
                  onChange={(event) => {
                    if (isTextEmpty(event.target.value)) {
                      alert('Course title cannot be empty!')
                      return
                    }
                    dispatch(courseActions.onChange(event))
                  }}
                  style={{
                    border: 'none',
                  }}
                />
                {/* <p className='text-sm text-muted mb-0'>Course group</p> */}
                {courseState.languageIsReady && (
                  <CardHeaderButton
                    className='col4 md-col4 xs-col12 fontSizeResponsive'
                    customFn={() =>
                      dispatch(courseActions.onChangeLanguageIsReady())
                    }
                    text={
                      courseState.languageIsReady === 1
                        ? 'Unpublish'
                        : 'Publish'
                    }
                  ></CardHeaderButton>
                )}
              </div>
            </div>
            <div className='col6 lg-col12 mr-3'>
              <div className='nav-wrapper sm-py1 p0' style={{marginLeft: "15px"}}>
                <Nav
                  className='nav-fill flex-column flex-sm-row p-1 rounded nav-background leon'
                  id='tabs-text'
                  pills
                  role='tablist'
                >
                  <NavItem className='col4 xs-col12' style={{ margin: 0 }}>
                    <NavLink
                      aria-selected={courseState.currentTab === 'timeline'}
                      onClick={() =>
                        dispatch(courseActions.setCurrentTab('timeline'))
                      }
                      className={`text-darker cursorPointer ${
                        courseState.currentTab === 'timeline'
                          ? ''
                          : 'bg-transparent shadow-none'
                      }`}
                      role='tab'
                    >
                      <span className='fontSizeResponsive'>
                        <FontAwesomeIcon
                          icon={faArrowTrendUp}
                          className='pr-2'
                        />
                        {language.courses ? language.courses.timeline : null}
                      </span>
                    </NavLink>
                  </NavItem>
                  <NavItem className='col4 xs-col12' style={{ margin: 0 }}>
                    <NavLink
                      onClick={() =>
                        dispatch(courseActions.setCurrentTab('tools'))
                      }
                      className={`text-darker cursorPointer ${
                        courseState.currentTab === 'tools'
                          ? ''
                          : 'bg-transparent shadow-none'
                      }`}
                      role='tab'
                    >
                      <span className='fontSizeResponsive'>
                        <FontAwesomeIcon
                          icon={faScrewdriverWrench}
                          className='pr-2'
                        />
                        {language.courses ? language.courses.tools : null}
                      </span>
                    </NavLink>
                  </NavItem>
                  <NavItem className='col4 xs-col12' style={{ margin: 0 }}>
                    <NavLink
                      onClick={() =>
                        dispatch(courseActions.setCurrentTab('settings'))
                      }
                      className={`text-darker cursorPointer ${
                        courseState.currentTab === 'settings'
                          ? ''
                          : 'bg-transparent shadow-none'
                      }`}
                      role='tab'
                    >
                      <span className='fontSizeResponsive'>
                        <FontAwesomeIcon icon={faGear} className='pr-2' />
                        {language.general ? language.general.my_settings : null}
                      </span>
                    </NavLink>
                  </NavItem>
                </Nav>
              </div>
            </div>
          </Row>
        </CardBody>
      </Card>

      <div className='content-row'>
        {courseState.currentTab === 'timeline' ? (
          <Row className=''>
            <Col md='7' lg='8' xl='9'>
              <Card className='minHeight60'>
                {courseState.contentLoading ? (
                  <div className='dFlex itemsCenter justifyCenter minHeight60'>
                    <Loader color='default' />
                  </div>
                ) : (
                  <div className='col-auto'>
                    <SortableContent
                      courseId={courseState?.course_id}
                      deleteContent={(contentId, languageId) => {
                        dispatch(
                          courseActions.deleteContent(contentId, languageId)
                        )
                        dispatch(invalidateCoursesOverview())
                      }}
                      setContentQuizEditing={(content) =>
                        dispatch(courseActions.setContentQuizEditing(content))
                      }
                      content={courseState?.content}
                      onReorder={(oldIndex, newIndex) =>
                        dispatch(
                          courseActions.reorderCourseContent(oldIndex, newIndex)
                        )
                      }
                      language={language}
                      language_id={language_id}
                    />
                  </div>
                )}
              </Card>
            </Col>
            <Col md='5' lg='4' xl='3' className='pl-md-0'>
              <Card className='minHeight60'>
                {!language ? (
                  <div className='dFlex itemsCenter justifyCenter minHeight60'>
                    <Loader color='default' />
                  </div>
                ) : (
                  <div className='tl-contents d-flex flex-column align-items-center justify-content-evenly p-2 '>
                    {/* <Link
                      to={`/course/${courseState.course_id}/edit/add-subtitle`}
                      className='tl-icon-btn '
                    >
                      <FontAwesomeIcon
                        icon={faHeading}
                        className='button-icon'
                      />
                      <span className='edit__course__sidebar__span'>
                        {language.courses
                          ? language.courses.add_subtitle
                          : null}
                      </span>
                    </Link> */}
                    <Link
                      to={`/course/${courseState.course_id}/edit/add-text`}
                      className='tl-icon-btn '
                    >
                      <FontAwesomeIcon icon={faFont} className='button-icon' />
                      <span className='edit__course__sidebar__span'>
                        {language.courses ? language.courses.add_text : null}
                      </span>
                    </Link>
                    <Link
                      to={`/course/${courseState.course_id}/edit/add-html`}
                      className='tl-icon-btn'
                    >
                      <FontAwesomeIcon icon={faCode} className='button-icon' />
                      <span className='edit__course__sidebar__span'>
                        {language.courses ? language.courses.add_html : null}
                      </span>
                    </Link>
                    <Link
                      to={`/course/${courseState.course_id}/edit/add-video`}
                      onClick={() =>
                        dispatch(courseActions.toggleUploadPage(true))
                      }
                      className='tl-icon-btn'
                    >
                      <FontAwesomeIcon icon={faVideo} className='button-icon' />
                      <span className='edit__course__sidebar__span'>
                        {language.courses ? language.courses.add_video : null}
                      </span>
                    </Link>

                    <Link
                      to={`/course/${courseState.course_id}/edit/add-file`}
                      onClick={() =>
                        dispatch(courseActions.toggleUploadFilePage(true))
                      }
                      className='tl-icon-btn'
                    >
                      <FontAwesomeIcon icon={faFile} className='button-icon' />
                      <span className='edit__course__sidebar__span'>
                        {language.courses ? language.courses.add_file : null}
                      </span>
                    </Link>
                    <Link
                      to={`/course/${courseState.course_id}/edit/add-scorm`}
                      onClick={() =>
                        dispatch(courseActions.toggleUploadScormPage(true))
                      }
                      className='tl-icon-btn'
                    >
                      <FontAwesomeIcon
                        icon={faFileArchive}
                        className='button-icon'
                      />
                      <span className='edit__course__sidebar__span'>
                        {language.courses ? language.courses.add_scorm : null}
                      </span>
                    </Link>

                    <Link
                      to={`/course/${courseState.course_id}/edit/add-lti`}
                      className='tl-icon-btn'
                    >
                      <FontAwesomeIcon icon={faLink} className='button-icon' />
                      <span className='edit__course__sidebar__span'>
                        {language.courses ? language.courses.add_lti : null}
                      </span>
                    </Link>

                    <Link
                      to={`/course/${courseState.course_id}/edit/add-existing-content`}
                      onClick={() =>
                        dispatch(
                          courseActions.fetchCourseExistingContent(language_id)
                        )
                      }
                      className='tl-icon-btn'
                    >
                      <FontAwesomeIcon
                        icon={faFileImport}
                        className='button-icon'
                      />
                      <span className='edit__course__sidebar__span'>
                        {language.courses
                          ? language.courses.add_existing_content
                          : null}
                      </span>
                    </Link>

                    <Link
                      to={`/course/${courseState.course_id}/edit/add-quiz`}
                      className='tl-icon-btn'
                      onClick={() => dispatch(courseActions.newContentQuiz())}
                    >
                      <FontAwesomeIcon
                        icon={faPenAlt}
                        className='button-icon'
                      />
                      <span className='edit__course__sidebar__span'>
                        {'Add Quiz'}
                      </span>
                    </Link>
                  </div>
                )}
              </Card>
            </Col>
          </Row>
        ) : null}
        {courseState.currentTab === 'tools' ? (
          <Row className=''>
            <Col md='7' lg='8' xl='9'>
              <Card className='minHeight60'>
                <div className='col-auto'>
                  <SortableContent
                    courseId={courseState?.course_id}
                    deleteContent={(contentId, languageId) =>
                      dispatch(
                        courseActions.deleteContent(contentId, languageId)
                      )
                    }
                    content={courseState?.content}
                    onReorder={(oldIndex, newIndex) =>
                      dispatch(
                        courseActions.reorderCourseContent(oldIndex, newIndex)
                      )
                    }
                    language={language}
                    language_id={language_id}
                  />
                </div>
              </Card>
            </Col>
            <Col md='5' lg='4' xl='3' className='pl-md-0'>
              <Card className='minHeight60'>
                <div className='tl-contents d-flex flex-column align-items-center justify-content-evenly p-2 '>
                  <Link
                    to={`/course/${courseState.course_id}/edit/quiz`}
                    className='tl-icon-btn'
                  >
                    <FontAwesomeIcon icon={faPenAlt} className='button-icon' />
                    <span>
                      {language.courses
                        ? language.courses.manage_questions
                        : null}
                    </span>
                  </Link>
                  <Link
                    to={`/course/${courseState.course_id}/edit/checklist`}
                    className='tl-icon-btn'
                  >
                    <FontAwesomeIcon icon={faCheck} className='button-icon' />
                    <span>
                      {language.courses
                        ? language.courses.manage_checklist
                        : null}
                    </span>
                  </Link>
                </div>
              </Card>
            </Col>
          </Row>
        ) : null}
        {courseState.currentTab === 'settings' ? (
          <Row>
            <Col lg='12'>
              <CourseSettings
                {...courseState}
                language={language}
                languages={languages}
                onSelectCourseThumb={(event) =>
                  dispatch(courseActions.onSelectCourseThumb(event))
                }
                setCourseAvailableLanguages={(value) => {
                  dispatch(courseActions.setCourseAvailableLanguages(value))
                }}
                fetchCourseAvailableLanguages={(id) =>
                  dispatch(
                    courseActions.fetchCourseAvailableLanguages(parseInt(id))
                  )
                }
                fetchAllCourses={() =>
                  dispatch(courseActions.fetchAllCourses())
                }
                onChangeSecondLevelApproval={() =>
                  dispatch(courseActions.onChangeSecondLevelApproval())
                }
                onChangeLanguageIsReady={() =>
                  dispatch(courseActions.onChangeLanguageIsReady())
                }
                onChangeIsActiveCourse={() =>
                  dispatch(courseActions.onChangeIsActiveCourse())
                }
                setEquivalentCourse={(value) => {
                  dispatch(courseActions.setEquivalentCourse(value))
                }}
                setKeywords={(keywords) =>
                  dispatch(courseActions.setKeywords(keywords))
                }
                onChange={(event) => dispatch(courseActions.onChange(event))}
                setCourseLanguage={(event) =>
                  dispatch(courseActions.setCourseLanguage(event))
                }
                removeCourseTranslation={(id) =>
                  dispatch(courseActions.removeCourseTranslation(id))
                }
                onSetExpirationDate={() =>
                  dispatch(courseActions.onSetExpirationDate())
                }
                setExpireDate={(e) => dispatch(courseActions.setExpireDate(e))}
                setExpirePeriod={(e) =>
                  dispatch(courseActions.setExpirePeriod(e))
                }
                setEmailFrequency={(value) =>
                  dispatch(courseActions.setEmailFrequency(value))
                }
                onChangeExpirationDate={(e) =>
                  dispatch(courseActions.onChangeExpirationDate(e))
                }
              />
            </Col>
          </Row>
        ) : null}
        <ToastContainer />
      </div>

      <Route
        exact
        path={`/course/${courseState.course_id}/edit/quiz`}
        render={(routeProps) => (
          <ManageQuestions
            {...courseState}
            {...routeProps}
            language={language}
            questionBank={questionBankState}
            onChangeOption={(index, property, value) =>
              dispatch(courseActions.onChangeOption(index, property, value))
            }
            reorderQuizzess={(quizzes) =>
              dispatch(courseActions.reorderQuizzess(quizzes))
            }
            onChangeQuestion={(property, value) =>
              dispatch(courseActions.onChangeQuestion(property, value))
            }
            deleteQuestion={(index) =>
              dispatch(courseActions.deleteQuestion(index))
            }
            saveQuestion={() => dispatch(courseActions.saveQuestion())}
            saveQuestionFromBank={(questions) =>
              dispatch(courseActions.saveQuestionFromBank(questions))
            }
            toggleCurrentQuestionDescription={(index) =>
              dispatch(courseActions.toggleCurrentQuestionDescription(index))
            }
            onChangeOptionDescription={(description, index) =>
              dispatch(
                courseActions.onChangeOptionDescription(description, index)
              )
            }
            deleteOption={(index) =>
              dispatch(courseActions.deleteOption(index))
            }
            editQuestion={(index) =>
              dispatch(courseActions.editQuestion(index))
            }
            deleteMatchOption={(id) =>
              dispatch(courseActions.deleteMatchOption(id))
            }
            setOptionImage={(index) =>
              dispatch(courseActions.setOptionImage(index))
            }
            setRetakeQuizCount={(value) =>
              dispatch(courseActions.setRetakeQuizCount(value))
            }
            setPassPercentage={(value) =>
              dispatch(courseActions.setPassPercentage(value))
            }
            toggleQuizRetake={() => dispatch(courseActions.toggleQuizRetake())}
            togglePassPercentage={() =>
              dispatch(courseActions.togglePassPercentage())
            }
            toggleRandomizeOrder={() =>
              dispatch(courseActions.toggleRandomizeOrder())
            }
            toggleQuizTimer={() => dispatch(courseActions.toggleQuizTimer())}
            undo={() => dispatch(courseActions.undo())}
            addOption={() => dispatch(courseActions.addOption())}
            addDistraction={() => dispatch(courseActions.addDistraction())}
            selectQuestion={(event) =>
              dispatch(courseActions.selectQuestion(event))
            }
          />
        )}
      />
      <Route
        exact
        path={`/course/${courseState.course_id}/edit/add-quiz`}
        render={(routeProps) => (
          <ContentQuiz
            {...courseState}
            {...routeProps}
            language={language}
            questionBank={questionBankState}
            onChangeOption={(index, property, value) =>
              dispatch(
                courseActions.onChangeOptionContentQuiz(index, property, value)
              )
            }
            reorderQuizzess={(quizzes) =>
              dispatch(courseActions.reorderQuizzess(quizzes))
            }
            onChangeQuestion={(property, value) =>
              dispatch(
                courseActions.onChangeContentQuizQuestion(property, value)
              )
            }
            deleteQuestion={(index) =>
              dispatch(courseActions.deleteQuestionContentQuiz(index))
            }
            saveQuestion={() =>
              dispatch(courseActions.saveContentQuizQuestion())
            }
            saveContentQuiz={() => dispatch(courseActions.saveContentQuiz())}
            saveQuestionFromBank={(questions) =>
              dispatch(courseActions.saveContentQuizQuestionFromBank(questions))
            }
            toggleCurrentQuestionDescription={(index) =>
              dispatch(
                courseActions.toggleCurrentContentQuizQuestionDescription(index)
              )
            }
            onChangeOptionDescription={(description, index) =>
              dispatch(
                courseActions.onChangeContentQuizOptionDescription(
                  description,
                  index
                )
              )
            }
            deleteOption={(index) =>
              dispatch(courseActions.deleteOptionContentQuiz(index))
            }
            editQuestion={(index) =>
              dispatch(courseActions.editContentQuestion(index))
            }
            deleteMatchOption={(id) =>
              dispatch(courseActions.deleteMatchOptionContentQuiz(id))
            }
            setOptionImage={(index) =>
              dispatch(courseActions.setOptionImageContentQuiz(index))
            }
            setRetakeQuizCount={(value) =>
              dispatch(courseActions.setRetakeQuizCount(value))
            }
            setPassPercentage={(value) =>
              dispatch(courseActions.setContentQuizPassPercentage(value))
            }
            toggleQuizRetake={() => dispatch(courseActions.toggleQuizRetake())}
            togglePassPercentage={() =>
              dispatch(courseActions.toggleContentQuizPassPercentage())
            }
            toggleRandomizeOrder={() => dispatch(courseActions.toggleConten())}
            toggleQuizTimer={() =>
              dispatch(courseActions.toggleContentQuizQuizTimer())
            }
            toggleContentQuizPassable={() =>
              dispatch(courseActions.toggleContentQuizPassable())
            }
            undo={() => dispatch(courseActions.undoContentQuiz())}
            addOption={() => dispatch(courseActions.addOptionContentQuiz())}
            addDistraction={() =>
              dispatch(courseActions.addDistractionContentQuiz())
            }
            selectQuestion={(event) =>
              dispatch(courseActions.selectContentQuizQuestion(event))
            }
            onChangeContentQuizName={(event) =>
              dispatch(courseActions.onChangeContentQuizName(event))
            }
          />
        )}
      />

      <Route
        exact
        path={`/course/${courseState.course_id}/edit/add-quiz/:id`}
        render={(routeProps) => (
          <ContentQuiz
            {...courseState}
            {...routeProps}
            language={language}
            questionBank={questionBankState}
            onChangeOption={(index, property, value) =>
              dispatch(
                courseActions.onChangeOptionContentQuiz(index, property, value)
              )
            }
            reorderQuizzess={(quizzes) =>
              dispatch(courseActions.reorderQuizzess(quizzes))
            }
            onChangeQuestion={(property, value) =>
              dispatch(
                courseActions.onChangeContentQuizQuestion(property, value)
              )
            }
            deleteQuestion={(index) =>
              dispatch(courseActions.deleteQuestionContentQuiz(index))
            }
            saveQuestion={() =>
              dispatch(courseActions.saveContentQuizQuestion())
            }
            saveContentQuiz={() => dispatch(courseActions.saveContentQuiz())}
            saveQuestionFromBank={(questions) =>
              dispatch(courseActions.saveContentQuizQuestionFromBank(questions))
            }
            toggleCurrentQuestionDescription={(index) =>
              dispatch(
                courseActions.toggleCurrentContentQuizQuestionDescription(index)
              )
            }
            onChangeOptionDescription={(description, index) =>
              dispatch(
                courseActions.onChangeContentQuizOptionDescription(
                  description,
                  index
                )
              )
            }
            deleteOption={(index) =>
              dispatch(courseActions.deleteOptionContentQuiz(index))
            }
            editQuestion={(index) =>
              dispatch(courseActions.editContentQuestion(index))
            }
            deleteMatchOption={(id) =>
              dispatch(courseActions.deleteMatchOptionContentQuiz(id))
            }
            setOptionImage={(index) =>
              dispatch(courseActions.setOptionImageContentQuiz(index))
            }
            setRetakeQuizCount={(value) =>
              dispatch(courseActions.setRetakeQuizCount(value))
            }
            setPassPercentage={(value) =>
              dispatch(courseActions.setContentQuizPassPercentage(value))
            }
            toggleQuizRetake={() => dispatch(courseActions.toggleQuizRetake())}
            togglePassPercentage={() =>
              dispatch(courseActions.toggleContentQuizPassPercentage())
            }
            toggleRandomizeOrder={() => dispatch(courseActions.toggleConten())}
            toggleQuizTimer={() =>
              dispatch(courseActions.toggleContentQuizQuizTimer())
            }
            toggleContentQuizPassable={() =>
              dispatch(courseActions.toggleContentQuizPassable())
            }
            undo={() => dispatch(courseActions.undoContentQuiz())}
            addOption={() => dispatch(courseActions.addOptionContentQuiz())}
            addDistraction={() =>
              dispatch(courseActions.addDistractionContentQuiz())
            }
            selectQuestion={(event) =>
              dispatch(courseActions.selectContentQuizQuestion(event))
            }
            onChangeContentQuizName={(event) =>
              dispatch(courseActions.onChangeContentQuizName(event))
            }
          />
        )}
      />
      <Route
        exact
        path={`/course/${courseState.course_id}/edit/checklist`}
        render={(routeProps) => (
          <ManageChecklist
            {...courseState}
            {...routeProps}
            cancelSection={() => dispatch(courseActions.cancelSection())}
            addSectionItem={() => dispatch(courseActions.addSectionItem())}
            addSection={() => dispatch(courseActions.addSection())}
            onChangeSection={(event) =>
              dispatch(courseActions.onChangeSection(event))
            }
            onChangeSectionItem={(index, value) =>
              dispatch(courseActions.onChangeSectionItem(index, value))
            }
            onChangeDescription={(name, value) =>
              dispatch(courseActions.onChangeDescription(name, value))
            }
            removeSectionItem={(index) =>
              dispatch(courseActions.removeSectionItem(index))
            }
            editSection={(index) => dispatch(courseActions.editSection(index))}
            deleteSection={(index) =>
              dispatch(courseActions.deleteSection(index))
            }
            saveSection={() => dispatch(courseActions.saveSection())}
            saveDescription={() => dispatch(courseActions.saveDescription())}
            language={language}
            backPath={`/course/${courseState.course_id}/edit`}
          />
        )}
      />
      <Route
        exact
        path={`/course/${courseState.course_id}/edit/lti/:id`}
        render={(routeProps) => (
          <ManageLTI
            {...courseState}
            {...routeProps}
            language={language}
            fetchLtiContent={(id) =>
              dispatch(courseActions.fetchLtiContent(id))
            }
            onChangeTitleText={(event) =>
              dispatch(courseActions.onChangeTitleText(event))
            }
            onChangeLaunchUrl={(event) =>
              dispatch(courseActions.onChangeLaunchUrl(event))
            }
            onChangeConsumerKey={(event) =>
              dispatch(courseActions.onChangeConsumerKey(event))
            }
            onChangeSharedSecret={(event) =>
              dispatch(courseActions.onChangeSharedSecret(event))
            }
            onChangeCustomParameters={(event) =>
              dispatch(courseActions.onChangeCustomParameters(event))
            }
            saveLTI={(id) => dispatch(courseActions.saveLTI(id))}
            deleteContent={(id) => dispatch(courseActions.deleteContent(id))}
            setContentRequired={(id) =>
              dispatch(courseActions.setContentRequired(id))
            }
          />
        )}
      />

      <Route
        exact
        path={`/course/${courseState.course_id}/edit/scorm/:id`}
        render={(routeProps) => (
          <ManageScorm
            {...courseState}
            {...routeProps}
            language={language}
            fetchTextContent={(id) =>
              dispatch(courseActions.fetchTextContent(id))
            }
            onChangeText={(type, event) =>
              dispatch(courseActions.onChangeText(type, event))
            }
            onChangeTitleText={(event) =>
              dispatch(courseActions.onChangeTitleText(event))
            }
            updateScormContent={(id) =>
              dispatch(courseActions.updateScormContent(id))
            }
            deleteContent={(id) => dispatch(courseActions.deleteContent(id))}
            setContentRequired={(id) =>
              dispatch(courseActions.setContentRequired(id))
            }
          />
        )}
      />
      <Route
        exact
        path={`/course/${courseState.course_id}/edit/video/:id`}
        render={(routeProps) => (
          <ManageVideos
            {...courseState}
            {...routeProps}
            language={language}
            fetchTextContent={(id) =>
              dispatch(courseActions.fetchTextContent(id))
            }
            onChangeText={(type, event) =>
              dispatch(courseActions.onChangeText(type, event))
            }
            onChangeTitleText={(event) =>
              dispatch(courseActions.onChangeTitleText(event))
            }
            updateVideoContent={(id) =>
              dispatch(courseActions.updateVideoContent(id))
            }
            deleteContent={(id) => dispatch(courseActions.deleteContent(id))}
            setContentRequired={(id) =>
              dispatch(courseActions.setContentRequired(id))
            }
          />
        )}
      />

      <Route
        exact
        path={`/course/${courseState.course_id}/edit/subtitle/:id`}
        render={(routeProps) => (
          <ManageSubtitle
            {...courseState}
            {...routeProps}
            language={language}
            fetchTextContent={(id) =>
              dispatch(courseActions.fetchTextContent(id))
            }
            onChangeText={(type, event) =>
              dispatch(courseActions.onChangeText(type, event))
            }
            onChangeTitleText={(event) =>
              dispatch(courseActions.onChangeTitleText(event))
            }
            saveSubtitleContent={(id) =>
              dispatch(courseActions.saveSubtitleContent(id))
            }
            deleteContent={(id) => dispatch(courseActions.deleteContent(id))}
          />
        )}
      />

      <Route
        exact
        path={`/course/${courseState.course_id}/edit/html/:id`}
        render={(routeProps) => (
          <ManageHtml
            {...courseState}
            {...routeProps}
            language={language}
            fetchHtmlContent={(id) =>
              dispatch(courseActions.fetchHtmlContent(id))
            }
            onChangeText={(type, event) =>
              dispatch(courseActions.onChangeText(type, event))
            }
            manageHtml={(event) => dispatch(courseActions.manageHtml(event))}
            onChangeTitleText={(event) =>
              dispatch(courseActions.onChangeTitleText(event))
            }
            saveHtml={(id) => dispatch(courseActions.saveHtml(id))}
            deleteContent={(id) => dispatch(courseActions.deleteContent(id))}
          />
        )}
      />

      <Route
        exact
        path={`/course/${courseState.course_id}/edit/text/:id`}
        render={(routeProps) => (
          <ManageText
            {...courseState}
            {...routeProps}
            language={language}
            fetchTextContent={(id) =>
              dispatch(courseActions.fetchTextContent(id))
            }
            onChangeText={(type, event) =>
              dispatch(courseActions.onChangeText(type, event))
            }
            onChangeTitleText={(event) =>
              dispatch(courseActions.onChangeTitleText(event))
            }
            saveTextContent={(id) =>
              dispatch(courseActions.saveTextContent(id))
            }
            deleteContent={(id) => dispatch(courseActions.deleteContent(id))}
          />
        )}
      />
      <Route
        exact
        path={`/course/${courseState.course_id}/edit/file/:id`}
        render={(routeProps) => (
          <ManageFile
            {...courseState}
            {...routeProps}
            language={language}
            setRequired={(event) => dispatch(courseActions.setRequired(event))}
            fetchTextContent={(id) =>
              dispatch(courseActions.fetchTextContent(id))
            }
            updateFileContent={(id) =>
              dispatch(courseActions.updateFileContent(id))
            }
            deleteContent={(id) => dispatch(courseActions.deleteContent(id))}
            onChangeTitleText={(event) =>
              dispatch(courseActions.onChangeTitleText(event))
            }
          />
        )}
      />

      <Route
        exact
        path={`/course/${courseState.course_id}/edit/add-subtitle`}
        render={() => (
          <AddSubtitle
            {...courseState}
            language={language}
            onChangeTitleText={(event) =>
              dispatch(courseActions.onChangeTitleText(event))
            }
            addSubtitleContainer={() =>
              dispatch(courseActions.addSubtitleContainer())
            }
          />
        )}
      />
      <Route
        exact
        path={`/course/${courseState.course_id}/edit/add-text`}
        render={() => (
          <AddText
            {...courseState}
            language={language}
            onChangeTitleText={(event) =>
              dispatch(courseActions.onChangeTitleText(event))
            }
            onChangeNewText={(event) =>
              dispatch(courseActions.onChangeNewText(event))
            }
            setRequired={(event) => dispatch(courseActions.setRequired(event))}
            addTextContainer={() => dispatch(courseActions.addTextContainer())}
          />
        )}
      />
      <Route
        exact
        path={`/course/${courseState.course_id}/edit/add-html`}
        render={() => (
          <AddHtml
            {...courseState}
            language={language}
            onChangeTitleText={(event) =>
              dispatch(courseActions.onChangeTitleText(event))
            }
            onChangeNewText={(event) =>
              dispatch(courseActions.onChangeNewText(event))
            }
            setRequired={(event) => dispatch(courseActions.setRequired(event))}
            manageHtml={(newContent) =>
              dispatch(courseActions.manageHtml(newContent))
            }
            addHtml={() => dispatch(courseActions.addHtml())}
          />
        )}
      />

      <Route
        exact
        path={`/course/${courseState.course_id}/edit/add-video`}
        render={() => (
          <AddVideo
            {...courseState}
            language={language}
            onChangeTitleText={(event) =>
              dispatch(courseActions.onChangeTitleText(event))
            }
            onChangeNewText={(event) =>
              dispatch(courseActions.onChangeNewText(event))
            }
            setRequired={(event) => dispatch(courseActions.setRequired(event))}
            setRestrictVideo={(event) =>
              dispatch(courseActions.setRestrictVideo(event))
            }
            addUrlVideo={(event, handleCloseModal) =>
              dispatch(courseActions.addUrlVideo(event, handleCloseModal))
            }
            uploadVideo={(event, handleCloseModal) => {
              dispatch(courseActions.uploadVideo(event, handleCloseModal))
              dispatch(invalidateCoursesOverview())
            }}
            selectVideo={(event) => dispatch(courseActions.selectVideo(event))}
            toggleUploadPage={(val) =>
              dispatch(courseActions.toggleUploadPage(val))
            }
          />
        )}
      />
      <Route
        exact
        path={`/course/${courseState.course_id}/edit/add-file`}
        render={() => (
          <AddFile
            {...courseState}
            language={language}
            setRequired={(event) => dispatch(courseActions.setRequired(event))}
            onChangeTitleText={(event) =>
              dispatch(courseActions.onChangeTitleText(event))
            }
            onChangeNewText={(event) =>
              dispatch(courseActions.onChangeNewText(event))
            }
            toggleUploadFilePage={(val) =>
              dispatch(courseActions.toggleUploadFilePage(val))
            }
            uploadFile={(event) => {
              dispatch(courseActions.uploadFile(event))
              dispatch(invalidateCoursesOverview())
            }}
          />
        )}
      />
      <Route
        exact
        path={`/course/${courseState.course_id}/edit/add-scorm`}
        render={() => (
          <AddScorm
            {...courseState}
            language={language}
            setRequired={(event) => dispatch(courseActions.setRequired(event))}
            onChangeTitleText={(event) =>
              dispatch(courseActions.onChangeTitleText(event))
            }
            onChangeNewText={(event) =>
              dispatch(courseActions.onChangeNewText(event))
            }
            toggleUploadScormPage={(val) =>
              dispatch(courseActions.toggleUploadScormPage(val))
            }
            uploadScorm={(event) => {
              dispatch(courseActions.uploadScorm(event))
              dispatch(invalidateCoursesOverview())
            }}
          />
        )}
      />

      <Route
        exact
        path={`/course/${courseState.course_id}/edit/add-lti`}
        render={() => (
          <AddLTIContent
            {...courseState}
            language={language}
            setRequired={(event) => dispatch(courseActions.setRequired(event))}
            onChangeTitleText={(event) =>
              dispatch(courseActions.onChangeTitleText(event))
            }
            onChangeLTI={(event) => dispatch(courseActions.onChangeLTI(event))}
            addLTI={() => dispatch(courseActions.addLTI())}
          />
        )}
      />
      <Route
        exact
        path={`/course/${courseState.course_id}/edit/add-existing-content`}
        render={() => (
          <AddExistingContent
            {...courseState}
            language={language}
            setRequired={(event) => dispatch(courseActions.setRequired(event))}
            onChangeTitleText={(event) =>
              dispatch(courseActions.onChangeTitleText(event))
            }
            onChangeLTI={(event) => dispatch(courseActions.onChangeLTI(event))}
            addLTI={() => dispatch(courseActions.addLTI())}
            setPaginationPageOfItems={(pageOfItems) =>
              dispatch(courseActions.setPaginationPageOfItems(pageOfItems))
            }
            addExistingContent={(contentId, languageId) => {
              dispatch(courseActions.addExistingContent(contentId, languageId))
              dispatch(invalidateCoursesOverview())
            }}
            setSearchValueExistingContent={(event) =>
              dispatch(courseActions.setSearchValueExistingContent(event))
            }
          />
        )}
      />
    </div>
  )
}

export default EditCourse
